/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2019-12-03 15:33:32
 */
export default {
  titleText: {
    value: ''
  },
  titleColor: {
    value: '#000'
  },
  titleSize: {
    value: '18'
  },
  titleWeight: {
    value: false
  },
  subTitleText: {
    value: ''
  },
  subTitleColor: {
    value: '#000'
  },
  subTitleSize: {
    value: '12'
  },
  subTitleWeight: {
    value: false
  },
  chartWidth: {
    value: '100%'
  },
  chartHeight: {
    value: '100%'
  }
}


// WEBPACK FOOTER //
// src/routes/customChart/components/baseFiled.js